import { useSelector } from "react-redux";
import { Navigate, useRoutes } from "react-router-dom";
import ClientSideLayout from "../components/Booking-clientSide/layout/ClientSideLayout";
import OwnNotFound from "../components/common/OwnNotFound";
import OwnLayout from "../components/layout/OwnLayout";
import SecLayout from "../components/layout/SecLayout";
import BookingAppointment from "../pages/Booking-clientSide/appointment/BookingAppointment";
import BookingAppointmentPickDate from "../pages/Booking-clientSide/appointment/BookingAppointmentPickDate";
import BookingAppointmentPickTime from "../pages/Booking-clientSide/appointment/BookingAppointmentPickTime";
import CheckoutAppointment from "../pages/Booking-clientSide/appointment/CheckoutAppointment";
import ClientAppointmentAuth from "../pages/Booking-clientSide/appointment/ClientAuth";
import ClientLoginAppointment from "../pages/Booking-clientSide/appointment/ClientLoginAppointment";
import ClientRegisterAppointment from "../pages/Booking-clientSide/appointment/ClientRegisterAppointment";
import SelectServicesTeamMembers from "../pages/Booking-clientSide/appointment/SelectServicesTeamMembers";
import BookingGiftCard from "../pages/Booking-clientSide/giftCard/BookingGiftCard";
import CheckoutGiftCards from "../pages/Booking-clientSide/giftCard/CheckoutGiftCards";
import BookingMemberShip from "../pages/Booking-clientSide/membership/BookingMemberShip";
import CheckoutMemberships from "../pages/Booking-clientSide/membership/CheckoutMemberships.tsx";
import ClientAuth from "../pages/Booking-clientSide/membership/ClientAuth";
import ClientLoginMemberships from "../pages/Booking-clientSide/membership/ClientLoginMemberships";
import ClientRegisterMemberships from "../pages/Booking-clientSide/membership/ClientRegisterMemberships";
import MembershipsStartDate from "../pages/Booking-clientSide/membership/MembershipsStartDate.tsx";
import Home from "../pages/Home/Home";
import Calendar from "../pages/calendar/Calendar";
import Clients from "../pages/clients/Clients";
import OnBoarding from "../pages/onboarding/OnBoarding";
import OnlineBooking from "../pages/online-booking/OnlineBooking";
import Overview from "../pages/overview/Overview";
import Reports from "../pages/reports/Reports";
import Sales from "../pages/sales/Sales";
import { getStoredToken } from "../services/user-storage";
import routesAuthentication from "./routesAuthentication";
import routesCatalog from "./routesCatalog";
import routesSettings from "./routesSettings";
import routesSuperAdmin from "./routesSuperAdmin";
import routesTeamMember from "./routesTeamMember";
import SubscriptionPlans from "../pages/Subscription-plans/SubscriptionPlans";
function RoutesWrapper() {
  const currentUser = useSelector((s) => s?.user?.data);
  const isSalonOwner = currentUser?.user?.roles?.some(
    (s) => s?.name === "salon_owner",
  );
  const isAdmin = currentUser?.user?.roles?.some((s) => s?.name === "admin");
  const isOwnerHasSalon = currentUser?.user?.salon && isSalonOwner;
  // console.log(isOwnerHasSalon, 'isOwnerHasSalon');
  console.log(isAdmin, "isAdmin in router");
  const routes = useRoutes([
    {
      path: "*",
      element: <OwnNotFound />,
    },
    {
      path: "/",
      // element: <OwnLayout />,
      element: getStoredToken() ? (
        isOwnerHasSalon ? (
          <OwnLayout />
        ) : isAdmin ? (
          <OwnLayout />
        ) : (
          <Navigate to="/onboarding" replace />
        )
      ) : (
        <Navigate to="/login" replace />
      ),
      children: [
        {
          index: true,
          element: <Home />,
        },
        ...routesCatalog,
        ...routesTeamMember,
        ...routesSettings,
        ...routesSuperAdmin,
        {
          path: "/overview",
          element: <Overview />,
        },
        {
          path: "/subscription-plans",
          element: <SubscriptionPlans />,
        },
        {
          path: "/clients",
          element: <Clients />,
        },
        {
          path: "/sales",
          element: <Sales />,
        },
        {
          path: "/reports",
          element: <Reports />,
        },
        {
          path: "/calendar",
          element: <Calendar />,
        },
        {
          path: "/online-booking",
          element: <OnlineBooking />,
        },
      ],
    },
    {
      path: "/",
      element: getStoredToken() ? (
        <SecLayout />
      ) : (
        <Navigate to="/login" replace />
      ),
      children: [
        {
          path: "/onboarding",
          element: <OnBoarding />,
        },
      ],
    },
    {
      path: ":salonSlug",
      element: <ClientSideLayout />,
      children: [
        {
          path: "appointment",
          element: <BookingAppointment />,
        },
        {
          path: "appointment/pick-date",
          element: <BookingAppointmentPickDate />,
        },
        {
          path: "appointment/pick-date/team-members",
          element: <SelectServicesTeamMembers />,
        },
        {
          path: "appointment/pick-date/team-members/pick-time",
          element: <BookingAppointmentPickTime />,
        },

        {
          path: "appointment/pick-date/team-members/pick-time/checkout",
          element: <CheckoutAppointment />,
        },
        {
          path: "appointment/auth",
          element: <ClientAppointmentAuth />,
        },
        {
          path: "appointment/auth/login",
          element: <ClientLoginAppointment />,
        },
        {
          path: "appointment/auth/register",
          element: <ClientRegisterAppointment />,
        },
        {
          path: "gift-card",
          element: <BookingGiftCard />,
        },
        {
          path: "gift-card/checkout",
          element: <CheckoutGiftCards />,
        },
        {
          path: "membership",
          element: <BookingMemberShip />,
        },
        {
          path: "membership/pick-date",
          element: <MembershipsStartDate />,
        },
        {
          path: "membership/auth",
          element: <ClientAuth />,
        },
        {
          path: "membership/auth/login",
          element: <ClientLoginMemberships />,
        },
        {
          path: "membership/auth/register",
          element: <ClientRegisterMemberships />,
        },
        {
          path: "membership/pick-date/checkout",
          element: <CheckoutMemberships />,
        },
      ],
    },
    ...routesAuthentication,
  ]);
  return routes;
}

export default RoutesWrapper;
